export enum ClientEnvironmentName {
	PRODUCTION = 'PRODUCTION',
	STAGING = 'STAGING',
	DEVELOPMENT = 'DEVELOPMENT',
	LOCAL = 'LOCAL',
}

export type ClientId = 'default' | 'ioc';

export interface ClientEnvironment {
	production: boolean;

	environmentName: ClientEnvironmentName;

	/** Tenant/client identifier selected at build-time. */
	clientId: ClientId;

	frontendUrl: string;

	apiBaseUrl: string;

	socialSignIn: {
		googleClientId: string;
		appleClientId: string;
		microsoftClientId: string;
		microsoftAuthority: string;
		microsoftMyGenieClientId: string;
		microsoftMyGenieAuthority: string;
		microsoftTeamsIntegrationClientId: string;
		microsoftTeamsIntegrationAuthority: string;
		microsoftSharepointIntegrationClientId: string;
		microsoftSharepointIntegrationAuthority: string;
		microsoftWidgetSecurityClientId: string;
	};

	microsoftTeamsAppId: string | null; // if null, we don't show the admin link

	landingUrl: string;

	googleAdsId?: string;

	googleAnalyticsId?: string;

	imageCdn?: string;

	handbookUrl: string;
	organizationDashboardUrl: string;
	myGenieServer: string;
}
